import { useState, useEffect, useCallback } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

export default function useCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    try {
      const customersRef = collection(db, 'customers');
      const snapshot = await getDocs(customersRef);
      
      const customersData = snapshot.docs.map(doc => {
        const data = doc.data();
        const normalizedData = {
          id: doc.id,
          ...data,
          status: data.status === 'Active' || data.status === 'active' ? 'Active' : data.status,
          kyc: typeof data.kyc === 'string' ? data.kyc : data.kyc ? 'Verified' : 'Unverified',
          ref_id: data.ref_id || null,
          createdAt: data.createdAt || data.created_at,
          updatedAt: data.updatedAt || data.updated_at,
          balance: data.balance || 0,
          total_profit: data.total_profit || 0,
          full_name: data.full_name || `${data.first_name || ''} ${data.last_name || ''}`.trim() || null,
          source: data.ref_id ? 'referral' : 'admin'
        };
        return normalizedData;
      });
      
      const sortedCustomers = customersData.sort((a, b) => {
        const getDate = (date) => {
          if (date instanceof Date) return date;
          if (typeof date === 'object' && date.seconds) {
            return new Date(date.seconds * 1000);
          }
          return new Date(date);
        };
        
        const dateA = a.createdAt ? getDate(a.createdAt) : new Date(0);
        const dateB = b.createdAt ? getDate(b.createdAt) : new Date(0);
        return dateB - dateA;
      });
      
      setCustomers(sortedCustomers);
      setError(null);
    } catch (err) {
      console.error('Error fetching customers:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  const refreshCustomers = () => {
    fetchCustomers();
  };

  return { customers, loading, error, refreshCustomers };
}